import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    GenerateReport as GenerateReportMutation,
    GenerateReportVariables,
    GenerateReportInput,
} from 'nutshell-graphql-types';

import GENERATE_REPORT from '../mutations/generate-report.graphql';

export const useGenerateReport = (): {
    generateReport: (arg1: GenerateReportInput) => Promise<any>;
    isLoading: boolean;
    error: string | null | undefined;
} => {
    const [generateReport, {loading, error}] = useMutation<
        GenerateReportMutation,
        GenerateReportVariables
    >(GENERATE_REPORT);

    return {
        generateReport: (input: GenerateReportInput) => generateReport({variables: {input}}),
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
    };
};
